export default __webpack_public_path__ + "static/media/datetime.7dfaa9ec.png";